export default __webpack_public_path__ + "static/media/electric.b08b724e.svg";